import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('advoq-theme') || localStorage.getItem('vakil-theme') || 'light';
    localStorage.setItem('advoq-theme', saved);
    localStorage.removeItem('vakil-theme');
    // Apply immediately (before first paint) to avoid flash of wrong theme
    document.documentElement.classList.add(`${saved}-theme`);
    return saved;
  });

  // Keep <html> class in sync on theme changes so CSS variables cascade through body
  useEffect(() => {
    document.documentElement.classList.remove('light-theme', 'dark-theme');
    document.documentElement.classList.add(`${theme}-theme`);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('advoq-theme', next);
      localStorage.removeItem('vakil-theme');
      return next;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
